export default __webpack_public_path__ + "static/media/goldenglory10.a8708b74.jpg";